import axios from "../api/api"
import { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import { MDBContainer } from "mdb-react-ui-kit";

const GETDATABYID = "/api/audio"

const AudioModal = ({ show, setShow, id, setId }) => {
    const [content, Setcontent] = useState([])

    useEffect(() => {
        const getdatabyid = async () => {

            if (show === true) {
                const response = await axios.get(`${GETDATABYID}/${id}`)
                const data = response?.data?.audio
                Setcontent(data)
            }
            else {
                Setcontent([])
            }

        }
        getdatabyid()
    }, [id])

    // Handle hide
    const handleHide = () => {
        setId(null);
        setShow(false);
    }



    return (
        <Modal show={show} onHide={handleHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Audio Details -{content?.audiotitle} </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table bordered striped hover>
                    {
                        content?.audiofile?.map((item,i)=>(
                            <audio src={item?.location} controls className="w-100" key={i} />
                        ))
                    }
                </Table>
            </Modal.Body>
        </Modal>
    )
}

export default AudioModal;